module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/tee/1-bd5aa4a54aa889627b5facaa437c03a0.jpg";